export { default as AdminDashboardHomeComponent } from './adminDashboard'
export { default as StudentDashboardHomeComponent } from './studentdashboard'
export { default as TeacherDashboardHomeComponent } from './teacherDashboard'
export { default as ExecutiveDashboardHomeComponent } from './executiveHome'
export { default as CompanyDashboardHomeComponent } from './companyDashboardHome'
export { default as DefaultHomeComponent } from './defaultHome'
